module.exports = (array) => {

  return array[array.length - 1]

}



// WEBPACK FOOTER //
// ../node_modules/berries/lib/last.js